<template>
  <modal ref="modal" xlarge :show-header="false" @close="onClose">
    <div slot="modal-body">
      <InvestorProfile
        :tabs-mode="true"
        :show-apply-actions="showApplyActions"
      />
    </div>

    <div slot="modal-footer">
      <button
        type="button"
        class="btn btn-default"
        @click="$refs.modal.close()"
      >
        Cancel
      </button>
    </div>
  </modal>
</template>

<script>
import InvestorProfile from 'modules/investor-profile/InvestorProfile.vue'

export default {
  components: { InvestorProfile },
  props: {
    showApplyActions: { type: Boolean, default: true },
  },
  methods: {
    open(investor) {
      if (investor) {
        this.$store.commit(
          'investorProfile/SET_INVESTOR_PROFILE_DATA',
          investor,
        )
      }
      this.$refs.modal.open()
    },

    onClose() {
      setTimeout(() => {
        // postpone clear, otherwise bg image is changed before modal is hidden
        // which might confuse the user
        this.$store.commit('investorProfile/CLEAR')
      }, 50)
    },
  },
}
</script>
